import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import {useApolloClient} from '@apollo/client'
import Menu from '@mui/material/Menu'
import {useMsal} from '@azure/msal-react'
import {MenuPaperpropsValue} from '../SideBar/SideBarStyle'
import {handleRetainRecentSearches} from '../Dashboard/helper'

const handleLogout = async (instance, client, setAnchorUserInfoEl) => {
  await client.clearStore()
  client.cache.reset()
  setAnchorUserInfoEl(null)
  sessionStorage.clear()
  handleRetainRecentSearches()
  await instance.logout()
}

const UserInfoComponent = ({openUserInfo, anchorUserInfoEl, setAnchorUserInfoEl}) => {
  const client = useApolloClient()
  const {instance, accounts} = useMsal()
  const name = accounts[0]?.name
  const mail = accounts[0]?.username

  const handleClose = () => {
    setAnchorUserInfoEl(null)
  }

  return (
    <Box key='account_box'>
      <Menu
        open={openUserInfo}
        anchorEl={anchorUserInfoEl}
        id='account-menu'
        onClose={handleClose}
        transformOrigin={{horizontal: 'left', vertical: 'bottom'}}
        anchorOrigin={{horizontal: 'left', vertical: 'top'}}
        PaperProps={MenuPaperpropsValue}
      >
        <div style={{padding: '8px'}}>
          <Typography variant='listItemLarge' id='user-name'>
            {name}
          </Typography>
          <Typography
            sx={{
              color: (theme) => theme.palette.grey[600] // Replace 'primary.main' with the specific color from pTheme
            }}
          >
            {mail}
          </Typography>
        </div>
        <MenuItem
          sx={{
            color: (theme) => theme.palette.grey[600] // Replace 'primary.main' with the specific color from pTheme
          }}
          id='logout-btn'
          onClick={() => handleLogout(instance, client, setAnchorUserInfoEl)}
        >
          Log Out
        </MenuItem>
      </Menu>
    </Box>
  )
}

UserInfoComponent.propTypes = {
  openUserInfo: PropTypes.bool,
  anchorUserInfoEl: PropTypes.object,
  setAnchorUserInfoEl: PropTypes.func,
  anchorEl: PropTypes.shape({
    current: PropTypes.object
  })
}
export default UserInfoComponent
